import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'components/InputField/SelectField';
import DateRangeField from 'components/InputField/DateRangeField';

const labels = {
  register_from: 'Registered from',
  register_to: 'Registered to',
  logged_from: 'Logged from',
  logged_to: 'Logged to',
};

function Filters({
  searchQuery,
  changeFilterQuery,
  roles,
  onDateRangeChange
}) {
  return (
    <div className="container_admin_user">
      <DateRangeField
        onChange={onDateRangeChange}
        fromValue={searchQuery.register_from}
        toValue={searchQuery.register_to}
        fieldName={'register'}
        className="calendar_picker"
        labels={labels}
      />
      <DateRangeField
        onChange={onDateRangeChange}
        fromValue={searchQuery.logged_from}
        toValue={searchQuery.logged_to}
        fieldName={'logged'}
        className="calendar_picker"
        labels={labels}
      />
      <div className='user-type-filter'>
        <SelectField
          className='col s4'
          label='User Type'
          onChange={(e) => changeFilterQuery('user_type', e.target.value)}
          field_name='user_type'
          value={searchQuery.user_type || ''}
          options={roles}
        />
        <i onClick={(e) => changeFilterQuery('user_type', '')} className="material-icons icon_close">close</i>
      </div>
      <div className='col s4 search_admin'>
        <input id="search" type="submit" className="validate" />
        <label htmlFor="search">
          <i className="material-icons icon_search">search</i>
        </label>
        <input
          type="search"
          placeholder="Search"
          value={searchQuery.q}
          onChange={(e) => changeFilterQuery('q', e.target.value)} />
            <i onClick={(e) => changeFilterQuery('q', '')} className="material-icons icon_close">close</i>
      </div>
    </div>
  );
}

Filters.defaultProps = {};

Filters.propTypes = {};

export default Filters;



// WEBPACK FOOTER //
// ./src/components/Admin/User/Toolbar/Filters.jsx